import { AxiosResponse } from 'axios';
import { SET_PROJECT_FILES, SET_PROJECT_FILE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_PROJECT_FILE_ISLOADING,
  DELETE_PROJECT_FILE,
  EDIT_PROJECT_FILE,
  GET_PROJECT_FILES,
  GET_PROJECT_FILE,
  REGISTER_PROJECT_FILE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import ProjectFile from '@/services/project_file';
import { Module } from 'vuex';
import { EditProjectFile, RegisterProjectFile, GetProjectFile } from '@/dtos/project_file.dto';

const projectFile: Module<any, {}> = {
  state: {
    projectFile: {
      data: null,
      isLoading: false,
    },
    projectFiles: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    projectFile: (state: { projectFile: any }) => state.projectFile,
    projectFiles: (state: { projectFiles: any }) => state.projectFiles,
  },
  mutations: {
    [SET_PROJECT_FILE]: (
      state: { projectFile: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.projectFile.data = payload.data) : null,
        (state.projectFile.isLoading = payload.isLoading);
    },
    [SET_PROJECT_FILES]: (
      state: { projectFiles: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.projectFiles.data = payload.data) : null,
        (state.projectFiles.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_PROJECT_FILE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_FILE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectFile.registerProjectFile(
        payload as RegisterProjectFile
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PROJECT_FILE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_FILE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_FILE, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT_FILES]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_FILES, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectFile.getProjectFiles(
        payload as GetProjectFile
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_FILES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_FILES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_FILES, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT_FILE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_FILE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectFile.getProjectFiles(
        payload as GetProjectFile
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_FILE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_PROJECT_FILE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_FILE, { isLoading: false });
        return false;
      }
    },
    [EDIT_PROJECT_FILE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_FILE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectFile.editProjectFile(
        payload as EditProjectFile
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_FILE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_FILE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_FILE, { isLoading: false });
        return false;
      }
    },
    [DELETE_PROJECT_FILE]: async ({ commit }: any, payload: string) => {
      commit(SET_PROJECT_FILE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectFile.deleteProjectFile(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_FILE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_FILE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_FILE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_PROJECT_FILE_ISLOADING]: ({ commit }) => {
      commit(SET_PROJECT_FILE, { isLoading: false });
      commit(SET_PROJECT_FILES, { isLoading: false });
    },
  },
};

export default projectFile;

